import { POIs as P } from "@local-logic/client";
import { POIList, ScorePOIs } from "@local-logic/elements-react";
import { UseQueryResult } from "@tanstack/react-query";
import React from "react";
import { useMap } from "~/sdks/LocalContent/Map/MapGLMap/context";
import { useLocalContent } from "~/sdks/LocalContent/context";

const MapGLPOI = React.memo(
  ({ result, poi }: { result: UseQueryResult<P, unknown>; poi: keyof P }) => {
    const { activePOI, setActivePOI, hoveredPOI, setHoveredPOI } =
      useLocalContent();
    const { mapRef, mapPadding } = useMap();

    if (!result.data?.[poi]) {
      return null;
    }

    return (
      <ScorePOIs.Content key={poi} options={{ value: poi }}>
        <POIList.Root
          options={{
            type: "poi",
            data: result.data[poi],
            activePOI,
            hoveredPOI,
          }}
          onChange={(e) => {
            if (e.type === "poi-click") {
              const p = e.data;
              setActivePOI(p);

              const mapArea = window.innerWidth - mapPadding.left;
              const defaultMapCenter = window.innerWidth / 2;
              const xOffset = mapArea / 2 + mapPadding.left - defaultMapCenter;

              if (p) {
                mapRef.current?.flyTo({
                  zoom: 18,
                  center: [p.lng, p.lat],
                  duration: 1000,
                  offset: [xOffset, 0],

                  // Without this, some operating systems will prevent this from
                  // working. See comment:
                  // https://docs.mapbox.com/mapbox-gl-js/example/flyto-options/
                  essential: true,
                });
              }
            }

            if (e.type === "poi-hover") {
              setHoveredPOI(e.data);
            }
          }}
        />
      </ScorePOIs.Content>
    );
  }
);

MapGLPOI.displayName = "POI";

export default MapGLPOI;
